// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"351":"43f78cb8","873":"9414d4f2"}[chunkId] + ".chunk.css");